export default {
  'common.page.notfound': 'We did not find this page',
  'common.404error': 'Error 404',
  'common.login': 'Re-login',
  'common.404.welcome':
    'Hello {name}! The site you quote is currently unavailable.Please try again after admin granted access',
  'common.404note':
    "It seems something is disconnected.Don't find the page you requested, but there are several ways to take you back in the right direction. You can return to the previous page or visit our homepage.",
  'common.error.authorization':
    'Currently your account has not been assigned to access.please contact{email} for assistance.',
  'common.error.title.authorization': 'Confirm account authorization!',
};
